import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import ShopContent from '../components/ShopContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';

class Shop extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        return (
            <div>
                <Header/> 
                <PageHeader title={"Products: "+this.props.params.id}  slug={this.props.params.id} />
                <ShopContent slug={this.props.params.id}  />  
                <Footer/>
      
        
        </div>
       
        )
    }

}
export default withRouter(Shop);;